import axios from "axios";

const API_BASE_URL = "https://liman.finance/conversation";

const instance = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true, // Çerezlerin otomatik gönderilmesini sağlar
});

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.error("Unauthorized. Please log in again.");
    }
    return Promise.reject(error);
  }
);

const getConversations = async () => {
  try {
    const response = await instance.get("/get-conversations");
    const conversations = response.data.data;

    // updated_at tarihine göre sıralama (en yeni en üstte)
    conversations.sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at));
    console.log(conversations)
    return conversations;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch conversations");
  }
};

const createConversation = async (title) => {
  try {
    const response = await instance.post("/create-conversation", { title });
    return response.data.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to create conversation");
  }
};

const sendMessage = async ({ conversationId, question, threadId }) => {
  try {
    const response = await instance.post("/ask-question", {
      conversation_id: conversationId,
      question,
      thread_id: threadId,
    });
    return response.data.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to send message");
  }
};

const deleteConversation = async (conversationId) => {
  try {
    await instance.delete(`/delete-conversation/${conversationId}`);
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to delete conversation");
  }
};

const deleteAllConversations = async () => {
  try {
    await instance.delete("/delete-all-conversations");
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to delete all conversations");
  }
};

const getMessages = async (conversationId) => {
  try {
      const response = await instance.get(`/get-messages/${conversationId}`);
      console.log(response);

      // Gelen veriyi tarihe göre sıralama
      return response.data.data
          .sort((a, b) => new Date(a.created_at) - new Date(b.created_at)) // Tarihe göre sıralama (artandan küçüğe)
          .map((item) => item.content); // Sadece mesaj içeriklerini döndür
  } catch (error) {
      throw new Error(error.response?.data?.message || "Failed to fetch messages");
  }
};


const ChatService = {
  getConversations,
  createConversation,
  sendMessage,
  deleteConversation,
  deleteAllConversations,
  getMessages,
};

export default ChatService;